import { render, staticRenderFns } from "./DetailsLandings.vue?vue&type=template&id=2178c356"
import script from "./DetailsLandings.vue?vue&type=script&lang=js"
export * from "./DetailsLandings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports